import { render, staticRenderFns } from "./ModalFollowUp.vue?vue&type=template&id=2f2e609c&scoped=true"
import script from "./ModalFollowUp.vue?vue&type=script&lang=js"
export * from "./ModalFollowUp.vue?vue&type=script&lang=js"
import style0 from "./ModalFollowUp.vue?vue&type=style&index=0&id=2f2e609c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e609c",
  null
  
)

export default component.exports